import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { Download, Loader } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

const ExportPDFButton = ({ title, content, toolName, className = '' }) => {
  const { token } = useAuth();
  const { lang } = useLanguage();
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    if (!content) return;
    setExporting(true);
    try {
      const res = await axios.post(`${API}/export/pdf`, {
        title,
        content,
        tool_name: toolName,
      }, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `Krypton9_${((title) == null ? '' : String(title)).replace(/[^a-zA-Z0-9 ]/g, '').replace(/ /g, '_').substring(0, 40)}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error('PDF export failed:', e);
    } finally {
      setExporting(false);
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={exporting || !content}
      className={`btn-secondary export-pdf-btn ${className}`}
      data-testid="export-pdf-btn"
    >
      {exporting ? <Loader size={14} className="spin" /> : <Download size={14} />}
      {lang === 'nl' ? 'Exporteer PDF' : 'Export PDF'}
    </button>
  );
};

export default ExportPDFButton;
